import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    titleUnitName: {
      display: 'inline',
      fontSize: '0.8em',
      margin: theme.spacing(0, 1),
      color: theme.palette.text.secondary,
    },
  };
};
